import type { IRichText } from '@/interfaces';

export enum WrapperBackgroundColor {
  grey = 'Grey',
  white = 'White',
}

export enum WrapperEntryName {
  ContentItem = 'ContentItem',
}

export interface IWrapper {
  title?: string;
  subText?: string;
  subTextMobile?: string;
  backgroundColor: WrapperBackgroundColor;
  image?: {
    contentType?: string;
    url: string;
    description: string;
  };
  content?: IRichText;
  // biome-ignore lint/suspicious/noExplicitAny: entry list items vary by content type
  entryList?: any[];
}
